module.exports = __webpack_public_path__ + "img/atheva-logo.bdb27de9.svg";